import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util/strings'

const notificationCard = theme => css`
  background-color: ${theme.color.info['50']};
  border-radius: ${rem(6)};
  padding: ${rem(12)} ${rem(8)};
  color: ${theme.color.monochrome.black};
  text-align: center;
  margin: 0 ${rem(-3)} ${rem(8)};
`

const notificationHeading = theme => css`
  font-size: ${theme.fontSize.large};
  font-weight: ${theme.fontWeight.medium};
`

const btn = theme => css`
  min-height: ${rem(40)};
  border-radius: ${rem(6)};
  font-family: ${theme.font.gtWalsheimPro};
  width: 100%;
`

export const styles = {
  notificationCard,
  notificationHeading,
  btn,
}
